import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { S3DirectoryForm } from "./S3DirectoryForm";

export const EditS3DirectoryModal = ({ resourcePath, s3Directory, onEdit, showDocumentIngestion }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const toggleModal = () => setOpen(!open);
  const title = `Edit S3 Directory ${s3Directory.bucket_name}/${s3Directory.prefix}`;

  const handleAction = async (values) => {
    setError(null);
    try {
      const { data } = await api.put(`${resourcePath}/s3_directories/${s3Directory.id}`, snakifyKeys({ s3Directory: values }));

      if (data) {
        onEdit(data);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal}>Edit</Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{title}</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <S3DirectoryForm handleAction={handleAction} directory={s3Directory} showDocumentIngestion={showDocumentIngestion} />
        </ModalBody>
      </Modal>
    </>
  );
};
